export default "__VITE_ASSET__sbE3uuZ1__"